<template>
  <div id="app">
    <survey class="survery"></survey>
    <div class="app-bottom-text" id="bottomText">
      系统由
      <i class="logo-icon"></i>58问卷提供
    </div>
  </div>
</template>
<script>
import survey from './views/survey'
export default {
  name: 'app',
  data() {
    return {
      isIOS: /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
    }
  },
  components: {
    survey
  }
}

var fun = function(doc, win) {
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function() {
      var clientWidth = docEl.clientWidth
      if (!clientWidth) return

      //这里是假设在640px宽度设计稿的情况下，1rem = 20px；
      //可以根据实际需要修改
      docEl.style.fontSize = 20 * (clientWidth / 375) + 'px'
    }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
}
fun(document, window)
</script>

<style lang="scss">
html,
body {
  font: 16px 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', 'arial',
    'Tahoma', 'SimSun', 'sans-serif';
  width: 100%;
  margin: 0;
  min-height: 200px;
  user-select: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-size: 62.5%;
}
body,
dd,
dl,
dt,
h2,
h3,
h4,
h6,
li,
ol,
p,
ul {
  margin: 0;
  padding: 0;
  list-style: none;
  -webkit-text-size-adjust: none;
  -webkit-font-smoothing: antialiased;
  word-break: break-all;
}
body {
  background-color: #f0f0f0;
  overflow-x: hidden;
  overflow-y: scroll;
  opacity: 0;
  animation: page-fade-in 1s forwards;
  -webkit-overflow-scrolling: touch;
  --themeColor: #ff552d;
  --themeColor-light-1: #ffeeea;//rgba(255, 85, 46, 0.1);
  --themeColor-light-2: #ffddd5;//rgba(255, 85, 46, 0.2);
}
@keyframes page-fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
img {
  border: 0;
}
i,
h2,
h3,
h4,
h6 {
  font-style: normal;
}
a {
  cursor: pointer;
  text-decoration: none;
  color: #666;
}
*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
:focus {
  outline: none;
}
:visited {
  color: #999;
}
::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}
::-webkit-scrollbar-track-piece {
  -webkit-border-radius: 3px;
}
::-webkit-scrollbar-thumb:vertical {
  height: 5px;
  -webkit-border-radius: 0px;
  background-color: #666;
}
::-webkit-scrollbar-thumb:horizontal {
  width: 5px;
  -webkit-border-radius: 3px;
  background-color: #ccc;
}
::-webkit-scrollbar {
  -webkit-webkit-appearance: sliderthumb-horizontal;
  overflow-x: scroll;
}

.clear-fix {
  zoom: 1;
}
.clear-fix:after {
  display: block;
  clear: both;
  content: '';
}
.pull-left {
  float: left;
}
.pull-right {
  float: right;
}
#app {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.cubeic-right,
.el-message__content,
.el-message__icon,
.cube-toast-tip {
  // color: #67c23a !important;
  color: var(--themeColor) !important;
}
.el-message {
  .el-message__icon {
    font-size: 16px !important;
  }
  background-color: var(--themeColor-light-1) !important;
  border-color: var(--themeColor-light-2) !important;
}
.cube-toast .cube-popup-container .cube-popup-content {
  top: -100%;
  transform: translate(-50%, 70px);
}
@media screen and (max-width: 500px) {
  .cube-toast .cube-popup-content {
    transform: translateX(-50%)!important;
    margin-top: calc(2.5rem + 35px);
  }
}
/* .survery {
  flex: 1;
} */
.el-picker-panel__icon-btn {
  padding: 0 10px;
}
.app-bottom-text {
  text-align: center;
  color: #bbb;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 60px;
  // top: -4px;
  .logo-icon {
    text-align: center;
    background-image: url('./assets/58logo1.svg');
    background-repeat: no-repeat;
    background-size: contain;
    width: 16px;
    height: 16px;
    display: inline-block;
    margin: 0 5px;
  }
}
@supports (bottom: env(safe-area-inset-bottom)) {
  .app-bottom-text {
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue